import { Box, Button, Flex, Heading } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { MdCallEnd } from "react-icons/md";
import ChatFooter from "./Chatfooter";
import Chats from "./Chats";

export default function AgentChatWidget({
  messages,
  sendMessage,
  closeConversation,
  connected,
  chatWindowHeading,
  selectedChatBg,
  chatBg,
  buttonColorScheme,
  agencyLogoUrl
}) {
  const dummyRef = useRef(null);
  useEffect(() => {
    if (dummyRef.current) {
      dummyRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, dummyRef]);

  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      flexDir={"column"}
      bg={"white"}
      overflowY={"auto"}
      h={"70svh"}
    >
      <Flex
        borderTopRadius={"md"}
        w={"100%"}
        bg={selectedChatBg}
        color={"white"}
        p={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Heading fontSize={"xl"}>{`Visitor ${chatWindowHeading}`}</Heading>
        <Button
          size="xs"
          colorScheme="red"
          variant="solid"
          leftIcon={<MdCallEnd />}
          onClick={closeConversation}
        >
          Close
        </Button>
      </Flex>
      <Box w={"100%"} overflowY={"auto"} flex={1} p={3}>
        <Chats messages={messages} selectedChatBg={selectedChatBg} chatBg={chatBg} agencyLogoUrl={agencyLogoUrl} />
        <Box ref={dummyRef}></Box>
      </Box>
      <Box h={10} w={"100%"}>
        <ChatFooter connected={connected} sendMessage={sendMessage} buttonColorScheme={buttonColorScheme} />
      </Box>
    </Flex>
  );
}
